import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { SeedType, get_user_data } from "../../utils/common";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "@material-tailwind/react";
import { ToastContainer } from "react-toastify";
import { ErrorMessages, ErrorType } from "../../utils/constants";
import { errorToast } from "../../utils/toastNotify";
import { getFinalizedContentFileInfo, rollBackPrivateContent } from "../../api/axiosApi";


function ShowPublishedContent() {
    const location = useLocation();
    const [description, setDescription] = useState("");
    const navigate = useNavigate();
    const { id } = useParams();
    const [privateContentError, setPrivateContentError] = useState();

    const [privateContent, setPrivateContent] = useState<SeedType>();
    async function loadData(fileName: string) {
        try {
            const res = await getFinalizedContentFileInfo(fileName)
            console.log("resJson: ",res)
           
            const resJson = await res.data;
            if(resJson.status === 'success'){
                setDescription(resJson.content.description);
                setPrivateContent(resJson.content);
            }
            else{
                setPrivateContentError(resJson.message)
            }
        } catch (error: any) {
            if (error.response) {
                // Server responded with a non-2xx status code
                errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);
                throw new Error(`Error! status: ${error.response.status}`);
            } else {
                // No response received or other network errors
                errorToast("Network error. Please try again.");
                throw new Error("Network error");
            }
        }
    }

    useEffect(() => {
        if (get_user_data() !== null && get_user_data() !== undefined) {
            let fileName = "";
            if (location.state != null) {
                fileName = location.state.fileName;
                loadData(fileName);
            } else {
                if (id) {
                    loadData(id);
                }
            }
        } else {
            navigate("/user_login");
        }
    }, [location.state, id]);
    async function rollBack() {
        if (privateContent?.id) {
            try {
                const res = await rollBackPrivateContent(privateContent?.id);
                const resRollBack = await res.data;
                if (resRollBack.status === "success") {
                        navigate(`/my-exclusive-content/draft/${privateContent?.id}`, { state: { fileName: privateContent?.id } });
                } else {
                    errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);
                }
            } catch (error: any) {
                errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);
            }
        } else {
            try {
                const res = await rollBackPrivateContent(privateContent?.file_name);
                const resRollBack = await res.data;
                if (resRollBack.status === "success") {
                    navigate(`/my-exclusive-content/draft/${privateContent?.file_name}`, { state: { fileName: privateContent?.file_name } });
                } else {
                    errorToast(ErrorMessages[resRollBack.error as ErrorType]);
                }
            } catch (error: any) {
                errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);

            }
        }
    }
    return (
        <div className=" h-full pb-28">
        {privateContent ? (
        <div className="p-4 ">
            <div className="min-w-96">
                <label className="font-title">Title</label>
                <textarea
                    name=""
                    id=""
                    style={{ borderRadius: "5px", marginTop: "0.5rem" }}
                    value={privateContent?.title}
                    readOnly
                    className="shadow-lg w-full h-[7vh] resize-none px-2 focus:border-transparent outline-none "
                ></textarea>
            </div>
            <div className="min-w-96 pt-4 ">
                <label className="font-title">Description</label>
                <div>
                    <ReactQuill
                        theme="snow"
                        value={description}
                        modules={{ toolbar: false }}
                        readOnly={true}
                        style={{
                            backgroundColor: "white",
                            marginTop: "0.5rem"
                        }}
                    />
                </div>
            </div>
            <div className="p-6 text-center">
                {privateContent?.user_id === get_user_data().email ? (
                    <Button
                        className="min-w-36 h-10 font-bold bg-blue-400 text-white"
                        onClick={() => {
                            rollBack();
                        }}
                    >
                        Rollback
                    </Button>
                ) : (
                    ""
                )}
            </div>
            <ToastContainer toastStyle={{ marginTop: "8vh" }} />
        </div>
            ):(<div className="flex h-full justify-center items-center p-12 text-2xl">{privateContentError}</div> )}
            </div>
    );
}

export default ShowPublishedContent;
